import React from 'react';
import CountryList from '../Data/CountryList';
import HelpIcon from '../Fields/HelpIcon';
import HelpText from '../Fields/HelpText';

let Quote = require('../Managers/Quote.js');

const CountrySelectElement = React.createClass({
    propTypes: {
        helpText:   React.PropTypes.string,
        question:   React.PropTypes.string.isRequired,
        fieldName:  React.PropTypes.string.isRequired,
        options:    React.PropTypes.array.isRequired,
        onChange:   React.PropTypes.func,
    },

    getDefaultProps: function() {
        return {
            options: [],
        };
    },

    getInitialState: function() {
        return {
            selectValue: "Please select...",
            isHelpVisible: false,
            activeValue: (Quote.hasAnswer(this.props.fieldName) !== null) ? Quote.getCurrentAnswer(this.props.fieldName) : false,
        };
    },

    setActiveValue(event) {
        if ('0' !== event.target.value) {
            this.setState({
                activeValue: event.target.value,
            });
            Quote.set(this.props.fieldName, event.target.value);
        }
    },

    doValidation() {
        // @NOTE intentially blank - all validation for this element is taken care
        // of via its parent address component, but this function is left in
        // to make the calling code simpler
    },

    helpVisibility() {
        if (this.state.isHelpVisible) {
            this.setState({
                isHelpVisible: false,
            });
        } else {
            this.setState({
                isHelpVisible: true,
            });
        }
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },

    render: function() {
        let selectValue = this.state.selectValue;
        let countries = CountryList;
        let options = countries.map(function(item) {
            if (selectValue === item.value) {
                return (
                    <option selected key={item.value} value={item.value}>{item.name}</option>
                );
            } else {
                return (
                    <option key={item.value} value={item.value}>{item.name}</option>
                );
            }
        });

        return (
            <div>
                <label className="compound-component">{this.props.question}</label>
                {this.props.helpText ? <HelpIcon onClick={this.toggleHelpText} />: null}
                <select
                    name={this.props.fieldName}
                    id={this.props.fieldName}
                    onChange={this.setActiveValue}
                    value={this.state.activeValue !== null ? this.state.activeValue : 0}
                >
                    <option value={0}>{this.state.selectValue}</option>
                    {options}
                </select>
                {this.props.helpText ? <HelpText text={this.props.helpText} active={this.state.isHelpVisible} /> : null}
            </div>
        );
    }
});

export default CountrySelectElement;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/CountrySelectElement.js
 **/